import { decodeJwtPayload } from "@/lib/auth/decodeJwtPayload";
import type { Session } from "../types";
import { getTrimbleAccessToken, tidClient } from "./client";

export async function getSession(): Promise<Session | null> {
  if (!tidClient) return null;
  try {
    const user = await tidClient.getUser();
    if (!user) return null;
    return {
      userId: user.sub ?? "",
      username: user.email ?? user.sub ?? "",
    };
  } catch {
    return null;
  }
}

export async function getServerSession(): Promise<Session | null> {
  // Trimble tokens are in-memory on the client — not available server-side.
  // If the proxy route passes an Authorization header, decode it for a minimal session.
  try {
    const { headers } = await import("next/headers");
    const h = await headers();
    const authorization = h.get("authorization");
    if (!authorization?.startsWith("Bearer ")) return null;

    const token = authorization.slice(7);
    const payload = decodeJwtPayload(token);
    if (!payload?.sub) return null;
    if (payload.exp && (payload.exp as number) * 1000 < Date.now()) return null;

    return {
      userId: payload.sub as string,
      username: (payload.email as string) ?? (payload.sub as string),
    };
  } catch {
    return null;
  }
}

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = await getTrimbleAccessToken();
  if (!token) return {};
  return { authorization: `Bearer ${token}` };
}
